/* 🤖 this file was generated by svg-to-ts */
export const matIconInsertInvitation: {
  name: 'insert-invitation';
  data: string;
} = {
  name: 'insert-invitation',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V9h14v10zm0-12H5V5h14v2zm-2 5h-5v5h5v-5z"/></svg>`
};
